import * as R from 'ramda';
import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
// components
import { Table } from '../../components/table';
import { TitlePanel } from '../../components/title-panel';
import { openModal, closeModal } from '../../components/modal/actions';
import { transformPropDataFromSelectToString } from '../../components/edit-report/helpers';
// features
import { makeSelectInitialDataLoadedStatus } from '../permission/selectors';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// hooks
import useReport from '../../hooks/use-report';
import usePromptModal from '../../hooks/use-prompt-modal';
// ui
import { FixedFlex, RelativeBox, ZOrderWrapper, ModalCancelButton } from '../../ui';
// feature carrier-statistic-report
import * as A from './actions';
import { tableSettings, columnSettings, FILTER_PARAMS } from './settings';
import {
  makeSelectItemList,
  makeSelectTotalCount,
  makeSelectPagination,
  makeSelectUsedReport,
  makeSelectListLoading,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} from './selectors';
import {
  setReports,
  setUsedReport,
  setInitialState,
  setTableTitleSort,
  getItemListRequest,
  setTableTitleFilter,
  createReportRequest,
  updateReportRequest,
  resetListAndPagination,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
} from './actions';
//////////////////////////////////////////////////

export const renderTable = (props) => {
  const {
    loading,
    itemList,
    totalCount,
    pagination,
    selectedReport,
    titleSortValues,
    tableTitleFilters,
    getItemListRequest,
    handleTableTitleFilter,
  } = props;

  if (R.not(selectedReport)) return null;

  const data = {
    loading,
    totalCount,
    pagination,
    tableSettings,
    columnSettings,
    titleSortValues,
    tableTitleFilters,
    hasSelectable: false,
    handleTableTitleFilter,
    report: selectedReport,
    withResizableColumns: true,
    useSearchableColumns: true,
    itemList: R.values(itemList),
    useNewTitleFilterInputs: true,
    handleLoadMoreEntities: G.ifElse(loading, () => {}, getItemListRequest),
    filterProps: R.indexBy(R.prop(GC.FIELD_VALUE), transformPropDataFromSelectToString(FILTER_PARAMS)),
  };

  return <Table {...data} />;
};

const CarrierStatisticReport = (props) => {
  const {
    setInitialState,
    expandedContainer,
    closeExpandedContainer,
  } = props;

  const reportProps = useReport({
    A,
    reportModalMaxWidth: 1150,
    useDefaultReportModal: true,
    type: 'carrierStatisticReport',
    additionalReportProps: { disableSortByFields: true },
  });

  const { handleTableTitleFilter } = reportProps;

  const { handleOpenPromptModal } = usePromptModal(
    { ...props, ...reportProps },
    FILTER_PARAMS,
  );

  useEffect(() => () => {
    setInitialState();
  }, [setInitialState]);

  return (
    <RelativeBox
      pr={15}
      p={props.padding}
      height={props.height}
      maxHeight={props.maxHeight}
      bg={G.getTheme('pages.layOutBgColor')}
    >
      <ZOrderWrapper zIndex={2}>
        <TitlePanel
          {...props}
          {...reportProps}
          version={2}
          withCount={true}
          noExportable={true}
          popperWithCount={true}
          filterProps={FILTER_PARAMS}
          shouldSubmitFilterForm={true}
          hiddenRightFilterInfo={false}
          type={GC.CARRIER_STATISTIC_REPORT}
          handleOpenPromptModal={handleOpenPromptModal}
          title={`${G.getWindowLocale('titles:statistic', 'Statistic')}: ${R.pathOr('', ['carrierName'], props)}`}
        />
      </ZOrderWrapper>
      <ZOrderWrapper zIndex='1' height={props.height}>
        {renderTable({
          ...props,
          ...reportProps,
          handleTableTitleFilter,
        })}
      </ZOrderWrapper>
      {
        G.isTrue(expandedContainer) &&
        <FixedFlex
          bottom='0'
          width='100%'
          p='14px 20px'
          boxShadow='0 0 8px 0 rgb(0 0 0 / 20%)'
          background={G.getTheme('colors.white')}
        >
          <ModalCancelButton width={130} onClick={() => closeExpandedContainer(true)}>
            {G.getWindowLocale('actions:close', 'Close')}
          </ModalCancelButton>
        </FixedFlex>
      }
    </RelativeBox>
  );
};

const mapStateToProps = (state) => createStructuredSelector({
  itemList: makeSelectItemList(state),
  loading: makeSelectListLoading(state),
  totalCount: makeSelectTotalCount(state),
  pagination: makeSelectPagination(state),
  selectedReport: makeSelectUsedReport(state),
  requestPending: makeSelectReportStatus(state),
  reportList: makeSelectAvailableReports(state),
  titleSortValues: makeSelectTitleSortValues(state),
  tableTitleFilters: makeSelectTableTitleFilters(state),
  initialDataLoaded: makeSelectInitialDataLoadedStatus(state),
});

export default connect(mapStateToProps, {
  openModal,
  closeModal,
  setReports,
  setUsedReport,
  setInitialState,
  setTableTitleSort,
  getItemListRequest,
  setTableTitleFilter,
  createReportRequest,
  updateReportRequest,
  resetListAndPagination,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
})(CarrierStatisticReport);
